import { Component, HostBinding, OnInit, inject } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ActiveModal } from '@frontend/sports/modal/feature';
import { SettingsUrlParam, UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import { DsButton } from '@frontend/ui/button';

@Component({
    selector: 'ms-modal-pop-up-info',
    templateUrl: './modal-pop-up-info.component.html',
    imports: [DsButton],
    styleUrls: ['./modal-pop-up-info.component.scss'],
})
export class ModalPopUpComponent implements OnInit {
    private activeModal = inject(ActiveModal);
    private urlHelper = inject(UrlHelperService);
    sitecore = inject(Sitecore);

    @HostBinding('class') className = 'betting-settings-update-popup';
    settingsURL: string;

    ngOnInit(): void {
        this.settingsURL = this.urlHelper.getSettingsUrl(SettingsUrlParam.Betslip);
    }

    close(): void {
        this.activeModal.close();
    }
}
